/**
 * The SoundLoaderContext class provides security checks for files that load sound.
 * SoundLoaderContext objects are passed as an argument to the constructor and the
 * <codeph class="+ topic/ph pr-d/codeph ">load()</codeph> method of the Sound class.
 *
 */
var SoundLoaderContext = (function () {
    /**
     * Creates a new sound loader context object.
     * @param	bufferTime	The number of seconds to preload a streaming sound into a buffer
     *   before the sound starts to stream.
     * @param	checkPolicyFile	Specifies whether the existence of a URL policy file
     *   should be checked upon loading the object (true) or not.
     */
    function SoundLoaderContext(bufferTime, checkPolicyFile) {
        if (bufferTime === void 0) { bufferTime = 1000; }
        if (checkPolicyFile === void 0) { checkPolicyFile = false; }
    }
    return SoundLoaderContext;
}());
export { SoundLoaderContext };
